import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import HomeStartupOnePage from './pages/dark/home-startup-onepage';

import PageAbout2 from './pages/dark/page-about2';
import PageAbout3 from './pages/dark/page-about3';
import PageContact from './pages/dark/page-contact';

import PageError404 from './pages/dark/page-error404';
import PageFAQS from './pages/dark/page-FAQS';
import PageServices from './pages/dark/page-services';
import PageServicesDetails from './pages/dark/page-services-details';
import CleaningServiceDetails from './pages/dark/Cleaning-service-detail';
import PaintingServiceDetails from './pages/dark/Painting-service-detail';
import PestServiceDetails from './pages/dark/Pest-service-detail';
import RenovationServiceDetails from './pages/dark/Renovation-service-detail';
import SanitizationServiceDetails from './pages/dark/Sanitization-service-detail';


import PageServices2 from './pages/dark/page-services2';
import PageTeam from './pages/dark/page-team';
import PageTeamSingle from './pages/dark/page-team-single';

import Project3 from './pages/dark/project3';

import Project5 from './pages/dark/project5';


import PrivacyPolicy from './pages/dark/privacy-policy';
import LHomeStartupOnePage from './pages/light/home-startup-onepage';
import LPageAbout2 from './pages/light/page-about2';
import LPageAbout3 from './pages/light/page-about3';
import LPageContact from './pages/light/page-contact';
import LPageError404 from './pages/light/page-error404';
import LPageFAQS from './pages/light/page-FAQS';
import LPageServices from './pages/light/page-services';
import LPageServicesDetails from './pages/light/page-services-details';
import LPageServices2 from './pages/light/page-services2';
import LPageTeam from './pages/light/page-team';
import LPageTeamSingle from './pages/light/page-team-single';
import LProject3 from './pages/light/project3';
import LProject5 from './pages/light/project5';
import React from 'react';

function App() {
  return (
    <Router>
      <Routes>
        {/* <Route path="/" element={<Home />} /> */}
        <Route
          path="/"
          element={<HomeStartupOnePage />}
        />
        <Route path="/dark/page-about2" element={<PageAbout2 />} />
        <Route path="/dark/page-about3" element={<PageAbout3 />} />
        <Route path="/dark/page-contact" element={<PageContact />} />
        <Route path="/dark/page-error404" element={<PageError404 />} />
        <Route path="/dark/page-FAQS" element={<PageFAQS />} />
        <Route path="/dark/page-services" element={<PageServices />} />
        <Route
          path="/dark/page-services-details"
          element={<PageServicesDetails />}
        />
        <Route
          path="/dark/Cleaning-service-detail"
          element={<CleaningServiceDetails />}
        />
        <Route
          path="/dark/Painting-service-detail"
          element={<PaintingServiceDetails />}
        />
        <Route
          path="/dark/Pest-service-detail"
          element={<PestServiceDetails />}
        />
        <Route
          path="/dark/Renovation-service-detail"
          element={<RenovationServiceDetails />}
        />
        <Route
          path="/dark/Sanitization-service-detail"
          element={<SanitizationServiceDetails />}
        />
        <Route path='/dark/privacy-policy' element={<PrivacyPolicy />} />





        
        <Route path="/dark/page-services2" element={<PageServices2 />} />
        <Route path="/dark/page-team" element={<PageTeam />} />
        <Route path="/dark/page-team-single" element={<PageTeamSingle />} />
        <Route path="/dark/project3" element={<Project3 />} />  
        <Route path="/dark/project5" element={<Project5 />} />







        <Route
          path="/light/home-startup-onepage"
          element={<LHomeStartupOnePage />}
        />
        <Route path="/light/page-about2" element={<LPageAbout2 />} />
        <Route path="/light/page-about3" element={<LPageAbout3 />} />
        <Route path="/light/page-contact" element={<LPageContact />} />
        <Route path="/light/page-error404" element={<LPageError404 />} />
        <Route path="/light/page-FAQS" element={<LPageFAQS />} />
        <Route path="/light/page-services" element={<LPageServices />} />
        <Route
          path="/light/page-services-details"
          element={<LPageServicesDetails />}
        />
        <Route
          path="/light/Cleaning-service-detail"
          element={<CleaningServiceDetails />}
        />
        <Route
          path="/light/Painting-service-detail"
          element={<PaintingServiceDetails />}
        />
        <Route
          path="/light/Pest-service-detail"
          element={<PestServiceDetails />}
        />
        <Route
          path="/light/Renovation-service-detail"
          element={<RenovationServiceDetails />}
        />
        <Route
          path="/light/Sanitization-service-detail"
          element={<SanitizationServiceDetails />}
        />







        <Route path="/light/page-services2" element={<LPageServices2 />} />
        <Route path="/light/page-team" element={<LPageTeam />} />
        <Route path="/light/page-team-single" element={<LPageTeamSingle />} /> 
        <Route path="/light/project3" element={<LProject3 />} />
        <Route path="/light/project5" element={<LProject5 />} />
      </Routes>
    </Router>
  );
}

export default App;
